export const parentalConsentMinAge: number = 18;
